import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { SITE, SERVICES } from "@/lib/site";
import { CITY_PAGES } from "@/lib/locations";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-ink-950 text-white/60" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <img src="/img/logo-512.png" alt="Toronto Custom Signs & Wraps logo" className="w-12 h-12 object-contain" />
            <span className="font-display text-white text-lg">Toronto Custom Signs &amp; Wraps</span>
          </div>
          <p className="text-sm leading-relaxed max-w-md">
            Professional signs, architectural wraps, vinyl graphics, and installation services
            across Toronto &amp; the GTA. 3M Certified Preferred Installer.
          </p>
          <div className="mt-8 space-y-3 text-sm">
            <a href={SITE.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 hover:text-gold"><Phone size={15} className="text-gold"/> {SITE.phone}</a>
            <a href={SITE.emailHref} data-testid="footer-email" className="flex items-center gap-3 hover:text-gold"><Mail size={15} className="text-gold"/> {SITE.email}</a>
            <a href={SITE.instagramUrl} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 hover:text-gold"><Instagram size={15} className="text-gold"/> {SITE.instagram}</a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="eyebrow !text-white/70 mb-5">Services</h4>
          <ul className="space-y-3 text-sm">
            {SERVICES.map(s => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="hover:text-gold transition-colors" data-testid={`footer-service-${s.slug}`}>{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="eyebrow !text-white/70 mb-5">Areas Served</h4>
          <ul className="grid grid-cols-2 gap-y-3 text-sm">
            {SITE.areas.map(a => (
              <li key={a} className="flex items-center gap-2"><MapPin size={13} className="text-purple-hi"/> {a}</li>
            ))}
          </ul>
          <Link to="/service-areas" className="inline-flex items-center gap-2 mt-6 text-[12px] uppercase tracking-[0.2em] text-gold hover:text-gold-hi" data-testid="footer-service-areas">
            View all service pages <ArrowUpRight size={13}/>
          </Link>
          <div className="mt-8">
            <Link to="/contact" className="btn-gold !text-[11px] !py-3 !px-5" data-testid="footer-quote-btn">Request a Quote</Link>
          </div>
        </div>
      </div>

      {/* City landing pages — internal links for SEO */}
      <div className="border-t border-white/5 bg-ink-900/40">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-10">
          <h4 className="eyebrow !text-white/55 mb-5">Local pages</h4>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-2 text-[13px]">
            {CITY_PAGES.map(p => (
              <Link key={p.slug} to={`/${p.slug}`} className="text-white/55 hover:text-gold transition-colors" data-testid={`footer-city-${p.slug}`}>
                {p.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px] text-white/40">
          <span>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</span>
          <span className="tracking-[0.2em] uppercase">{SITE.website}</span>
        </div>
      </div>
    </footer>
  );
}
